import React from 'react';

import data from '../../data/contact';

const ContactIcons = () => (
  <ul className="icons">
    {data.map((s) => (
      <li key={s.label}>
        <a href={s.link} aria-label={s.label}>
          <img height="26" width="26" src={s.iconSrc} alt={s.label}/>
        </a>
      </li>
    ))}
  </ul>
);

export default ContactIcons;
